import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CAMPAIGNS_REPOSITORY } from '../domain/repositories/campaigns.repository';
import { NEWSLETTERS_REPOSITORY } from '../domain/repositories/newsletters.repository';
import { PROMOTIONS_REPOSITORY } from '../domain/repositories/promotions.repository';
import { CampaignsRemoteDatasource } from './datasources/remote/campaigns.remote-datasource';
import { NewslettersRemoteDatasource } from './datasources/remote/newsletters.remote-datasource';
import { PromotionsRemoteDatasource } from './datasources/remote/promotions.remote-datasource';
import { CampaignMapper } from './mappers/campaign.mapper';
import { NewsletterMapper } from './mappers/newsletter.mapper';
import { PromotionMapper } from './mappers/promotion.mapper';
import { CampaignsRepositoryImpl } from './repositories/campaigns.repository.impl';
import { NewslettersRepositoryImpl } from './repositories/newsletters.repository.impl';
import { PromotionsRepositoryImpl } from './repositories/promotions.repository.impl';

export function provideMarketingData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    CampaignsRemoteDatasource,
    PromotionsRemoteDatasource,
    NewslettersRemoteDatasource,
    CampaignMapper,
    PromotionMapper,
    NewsletterMapper,
    { provide: CAMPAIGNS_REPOSITORY, useClass: CampaignsRepositoryImpl },
    { provide: PROMOTIONS_REPOSITORY, useClass: PromotionsRepositoryImpl },
    { provide: NEWSLETTERS_REPOSITORY, useClass: NewslettersRepositoryImpl },
  ]);
}
